<template>
  <i class="v-icon" :class="type" :style="{color,fontSize}"></i>
</template>

<script>
export default {
  props: {
    type: {
      default: ""
    },
    size: {
      default: ""
    },
    color: {
      default: ""
    }
  },
  computed: {
    fontSize() {
      return String(this.size).replace(/^(.*\d)$/gm, "$1px");
    }
  },
  mounted() {
    this.$bindEvents(this.$el);
  }
};
</script>



// WEBPACK FOOTER //
// src/vue-ext/components/icon.vue